<div *ngIf="!data.Type">
    <div class="item" *ngFor="let item of breakdown">

        <div class="item_group">
            <span class="item_label">Item &nbsp;</span>
            <span class="item_value"> {{item.vendorItemName}}</span>
        </div>
    
        <div class="item_group">
            <span class="item_label">Vendor &nbsp;</span>
            <span class="item_value"> {{item.vendorName}}</span>
        </div>
    
        <div class="item_group">
            <span class="item_label">Qty &nbsp;</span>
            <span class="item_value"> {{item.localStock}}</span>
        </div>
    
        <div class="item_group">
            <span class="item_label">Price &nbsp;</span>
            <span class="item_value"> {{item.price | currency}}</span>
        </div>
    </div>
</div>

<div *ngIf="data.Type == 'Cost'">
    <div class="item-row" >
        <span class="item_label">Avg Cost:</span>
        <span class="item_value ms-1">{{data.tooltipData.avgCost | currency }}</span>
    </div>
    <div class="item-row">
        <span class="item_label">Prep Cost:</span>
        <span class="item_value ms-1">{{data.tooltipData.prepCost | currency }} </span>
    </div>
    <div class="item-row">
        <span class="item_label">Shipping Cost:</span>
        <span class="item_value ms-1">{{data.tooltipData.shipCost | currency }}</span>
    </div>
    <div class="item-row">
        <span class="item_label">Commission Fee:</span>
        <span class="item_value ms-1">{{data.tooltipData.CommissionFee | currency }}</span>
    </div>
    <div class="item-row">
        <span class="item_label">Fulfillment Fee:</span>
        <span class="item_value ms-1">{{data.tooltipData.FulfillmentFee | currency }}</span>
    </div>
</div>

<div *ngIf="data.Type == 'Profit'">
    <div class="item-row" >
        <span class="item_label">Revenue:</span>
        <span class="item_value ms-1">$58</span>
    </div>
    <div class="item-row">
        <span class="item_label">Qty Sold:</span>
        <span class="item_value ms-1">$35 </span>
    </div>
    <div class="item-row">
        <span class="item_label">Fess:</span>
        <span class="item_value ms-1">$15</span>
    </div>
    <div class="item-row">
        <span class="item_label">Profit:</span>
        <span class="item_value ms-1">$15</span>
    </div>
</div>

<div class="expected-info" *ngIf="data.Type == 'Expected Profit'">
    <div>
        <app-page-container-devider [title]="'Expected Profit'"></app-page-container-devider>
        <div class="item-row" *ngFor="let item of data.tooltipData">
            <span class="item_label">{{item.label}}:</span>
            <span class="item_value">{{(item.number) || 'N/A'}}</span>
        </div>
    </div>
    <div>
    <app-page-container-devider [title]="'sales Last 30 days'"></app-page-container-devider>
      <div class="item-row" *ngFor="let item of data.expectedData">
            <span class="item_label">{{item.label}}:</span>
            <span class="item_value">{{(item.number) || 'N/A'}}</span>
        </div>
    </div>
</div>
